import { load } from '@cashfreepayments/cashfree-js';


  let cashfree;

  let initializeSDK = async function () {
    cashfree = await load({
      //  mode: "production",  // Change to "sandbox" when you want to use test
      mode: "sandbox",  // Change to "production" when you want to use live
    });
    console.log("this is cashfree", cashfree);
  };

  initializeSDK();

  // subscriptions checout

 export const SubscriptionsCheckoutSdk = (sessionIdProp) => {
  initializeSDK();
  
    try {
      let sessionId = sessionIdProp;

      let checkoutOptions = {
        subsSessionId: sessionId,
        // subsSessionId:"sub_session_OyQ6sqyHbNZqXDrUtyng6kq3wesWhist7jXc-I4bfx2BWbGBWRLCuungwADrHHx9vjkW20vNsfGyft7dhqLZ_2ansxzgdYpQlmcUFeCXu3wBvCwpayment",
        redirectTarget: "_modal",
      };

      cashfree.subscriptionsCheckout(checkoutOptions).then((res) => {
        console.log("Subscription payment initialized", res);
        return res
      });
    } catch (error) {
      console.log(error);
      return console.error(error);
    }
 }





 
